import { Input } from "../../../components/Input/input";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { theme } from "../../../helpers/theme";
import { useMutation } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { updateUserOperator } from "../../../services/users/edit-user-operator";
import { StyledButton } from "../../../components/Button/button";
import { GoBackButton } from "../../../components/GoBackButton";
import { FormControlLabel, FormLabel, OutlinedInputProps, Radio, RadioGroup } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { pl } from "date-fns/locale";
import { Dayjs } from "dayjs";
import { useState } from "react";


export const EditUserOperatorDataForm = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const { imie, nazwisko, email, telefon, aktywny, aktywny_data_do } = (state);

  
  const [toDate, setToDate] = useState<Dayjs | Date | string | null >(aktywny_data_do);
  const [dateToInvalid, setDateToInvalid] = useState<string | null>(null);

  const activeValue = (active: Boolean | string) => {
    if (typeof active == "boolean") {
      return active
    } else {
      return active === "true" ? true : false
    }
  }

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };


  const UpdateUserOperatorMutation = useMutation(updateUserOperator, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", { toastId: "EditSuccessfully", ...settings });
    },
  });

  const validationSchema = yup.object({
    imie: yup
      .string()
      .required("Pole wymagane"),
    nazwisko: yup
      .string()
      .required("Pole wymagane"),
    email: yup
      .string()
      .email("Niepoprawny adres email")
      .required("Pole wymagane"),
    telefon: yup
      .string()
      .required("Pole wymagane")
      .max(9, "Niepoprawny numer telefonu")
      .min(9, "Niepoprawny numer telefonu")
      .matches(/^[0-9]+$/, "Niepoprawny numer telefonu")
      
  });
  const formik = useFormik({
    initialValues: {
        imie: String(imie),
        nazwisko: String(nazwisko),
        email: String(email),
        telefon: (telefon as string | number),
        aktywny: aktywny,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_operator: id,
        imie: values.imie,
        nazwisko: values.nazwisko,
        email: values.email,
        telefon: values.telefon,
        aktywny: activeValue(values.aktywny),
        aktywny_data_do: (toDate === null || formik.values.aktywny === "false") ? null : toDate,
      };

      UpdateUserOperatorMutation.mutate(body);
    },
  });


  return (
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
      <EditOperatorContainer>
      <BasicFormWrapper onSubmit={formik.handleSubmit}>
        <FormWrapper>
          <Input
            label="Imie"
            id="imie"
            name="imie"
            value={formik.values.imie}
            onChange={formik.handleChange}
            error={formik.touched.imie && Boolean(formik.errors.imie)}
            helperText={formik.touched.imie && formik.errors.imie}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
            />
          <Input
            label="Nazwisko"
            id="nazwisko"
            name="nazwisko"
            value={formik.values.nazwisko}
            onChange={formik.handleChange}
            error={formik.touched.nazwisko && Boolean(formik.errors.nazwisko)}
            helperText={formik.touched.nazwisko && formik.errors.nazwisko}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
            />
          <Input
            label="E-mail"
            id="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
            />
          <Input
            label="Telefon"
            id="telefon"
            name="telefon"
            value={formik.values.telefon}
            onChange={formik.handleChange}
            error={formik.touched.telefon && Boolean(formik.errors.telefon)}
            helperText={formik.touched.telefon && formik.errors.telefon}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
            />
            <FormLabel id="active-label" style={{textAlign: "center"}}>Aktywny</FormLabel>
            <RadioGroup
              aria-labelledby="active-label"
              defaultValue="true"
              name="aktywny"
              value={formik.values.aktywny}
              onChange={formik.handleChange}
              // error={formik.touched.aktywny && Boolean(formik.errors.aktywny)}
              // helperText={formik.touched.aktywny && formik.errors.aktywny}
              onBlur={formik.handleBlur}
              style={{flexDirection: "row", justifyContent: "space-evenly"}}
            >
              <FormControlLabel value="true" control={<Radio />} label="Aktywny" />
              <FormControlLabel value="false" control={<Radio />} label="Niekatywny" />
            </RadioGroup>
            <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
            <DatePickersWrapper>
              <DesktopDatePicker
                maxDate={new Date("9999-12-31")}
                views={["day"]}
                label="Aktywny do"
                disablePast
                disabled = {(formik.values.aktywny === "true" || formik.values.aktywny === true) ? false : true}
                value={toDate}
                InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
                onError={(error) => setDateToInvalid(error)}
                onChange={(newValue) => {
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <InputWrapper style={{ justifyContent: "flex-start" }}>
                    <Input
                      {...params}
                      helperText={null}
                      variant="filled"
                      sx={{
                        width: "100%",
                        // minWidth: "300px",
                      }}
                    />
                  </InputWrapper>
                )}
              />
            </DatePickersWrapper>
          </LocalizationProvider>
          <StyledButton disabled={!formik.isValid || UpdateUserOperatorMutation.isLoading || (dateToInvalid === null ? false : true)} type="submit" variant="contained">
              Zapisz
            </StyledButton>
        </FormWrapper>
      </BasicFormWrapper>
      </EditOperatorContainer>
    </>
  );
};

export default EditUserOperatorDataForm;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  z-index: 10000;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;

const EditOperatorContainer = styled.div`
  // height: 80vh;
  width: auto;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;
  // margin-bottom: 150px;

  @media ${theme.device.laptop} {
    margin-left: 320px;
    width: 70%;
    margin-top: 0px;
  }
  `;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;

const InputWrapper = styled.div`
  width: 100%;
  display: flex;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;

